import Teams from './teams'

export default Teams
